<template>
  <div class="gallery">
    <div>
      <div
        v-for="(option, index) in options"
        :key="index"
        :class="{image: true, active: activeTab === index}"
      >
        <figure class="image-container">
          <img
            width="859"
            height="624"
            :src="`${require(`@/assets/bias-fx2/sound-page/${option.photo}`)}`"
            alt
          >
        </figure>
      </div>
    </div>
    <div class="option">
      <div class="tabnav-wrapper">
        <nav class="tabnav">
          <div class="sliderBox">
            <div class="slide">
              <ul>
                <li
                  v-for="(option, index) in options"
                  :key="index"
                  :class="{'nav-item': true, active: activeTab === index}"
                  @click="activeTab = index"
                >
                  <p>{{ option.name }}</p>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </div>
    <div
      v-for="(option, index) in options"
      :key="index"
      class="caption"
    >
      <div
        id="caption-item-group"
        :class="{'caption-item': true, active: activeTab === index}"
        aria-hidden="true"
      >
        <div v-if="typeof option.caption === 'string'">
          <p>{{ option.caption }}</p>
        </div>
        <div v-else-if="Object.keys(option.caption).length === 4">
          <p>{{ option.caption[0] }}</p>
          <span>
            <sound-clip
              :url="option.caption[1].file"
              :name="option.caption[1].name"
            />
          </span>
          <span>
            <sound-clip
              :url="option.caption[2].file"
              :name="option.caption[2].name"
            />
          </span>
          <span>
            <sound-clip
              :url="option.caption[3].file"
              :name="option.caption[3].name"
            />
          </span>
        </div>
        <div v-else-if="Object.keys(option.caption).length > 0">
          <p v-if="option.caption.description">
            {{ option.caption.description }}
          </p>
          <span v-if="option.caption.dry">
            <sound-clip
              :url="option.caption.dry.file"
              :name="option.caption.dry.name"
            />
          </span>
          <span v-if="option.caption.wet">
            <sound-clip
              :url="option.caption.wet.file"
              :name="option.caption.wet.name"
            />
          </span>
        </div>
        <div v-else>
          <sound-clip-disabled :name="'即将推出'" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SoundClip from '@/components/soundclip'
import SoundClipDisabled from '@/components/soundclip-disable'
export default {
  components: {
    SoundClip,
    SoundClipDisabled
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    photos: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      activeTab: 0
    }
  },
  watch: {},
  methods: {}
}
</script>

<style lang="scss" scoped>
@import "../styles/base/breakpoint.scss";
@import "../styles/pages/bias-fx2.scss";

.image,
.caption-item {
  display: none;
}
.active {
  display: block;
}

.sliderBox {
  position: relative;
  @media (max-width: 768px) {
    float: none;
    margin: auto;
  }
  button[aria-label="previous"] {
    left: 0;
  }
  button[aria-label="next"] {
    left: auto;
    right: 0;
  }
  .sliderWrap {
    overflow: hidden;
    margin-left: 8.33%;
    .sliderContent {
      counter-reset: items;
      white-space: nowrap;
      margin: 1em 0;
      padding: 0;
      transition: left 1s;
      position: relative;
      left: 0;
      display: inline-block;

      li {
        display: inline-block;
        width: 25em;
        height: 20em;
        @media (max-width: 551px) {
          width: 20em;
        }
      }

      .itemArtist {
        background-size: cover;
        background-position: center;
        -webkit-filter: brightness(0.8) saturate(0) contrast(1.1);
        &:hover {
          -webkit-filter: brightness(1) saturate(1) contrast(1.1);
        }
      }
    }
  }

  button {
    border: none;
    background: none;
    font-size: 1.2em;
    position: absolute;
    top: 130%;
    left: 8.33%;
    padding: 0 20px 0 0;
    transform: translateY(-50%);
    color: color_guide_line("putty");

    &:hover {
      color: #747474;
    }

    &.right {
      left: auto;
      right: 0;
    }
  }
}

ul,
li {
  display: inline-block;
}
ul {
  width: 100%;
  list-style: none;
  padding-left: 0;
}
.sliderBox {
  .slide {
    white-space: nowrap;
    text-align: center;
    @include breakpoint("medium") {
      text-align: center;
    }
    ul {
      list-style: none;
      margin-top: 0rem;
      margin-bottom: 1rem;
      font-size: 0;
      margin-left: 0;
      overflow-x: scroll;
      width: 100%;
      display: inline-block;
      li {
        display: inline-block;
        font-size: 1.1rem;
        font-weight: 400;
        padding: 0rem 1rem 0rem 1rem;
        position: relative;
        border-bottom: 1px solid #999;
        &:first-child:nth-last-child(2) ~ li {
          margin-right: 0;
          padding-left: 1rem;
          padding-right: 0;
        }
        &:first-child:nth-last-child(2) {
          padding-left: 0;
        }
        &:first-child:nth-last-child(3) + li {
          padding-left: 1rem;
          padding-right: 1rem;
          @include breakpoint("medium") {
            width: auto;
          }
        }
        &:first-child:nth-last-child(3) {
          padding-left: 0;
        }
        &:last-child:nth-child(3) {
          padding-right: 0;
        }
        &:first-child:nth-last-child(4) ~ li {
        }
        &:first-child:nth-last-child(4) {
          padding-left: 0;
        }
        &:last-child:nth-child(4) {
          padding-right: 0;
        }
        p {
          margin-bottom: 0.3rem;
          display: inline-block;
          position: relative;
          padding-top: 1rem;
          padding-bottom: 1rem;
          color: color_guide_line("greyish");
          &::after {
            content: "";
            display: block;
            position: absolute;
            top: 100%;
            left: 100%;
            bottom: -5px;
            width: 0%;
            border-bottom: 1px solid color_guide_line("white");
            transition: 0.25s all linear;
          }
        }
        &:hover {
          p {
            &::after {
              width: 100%;
              left: 0;
            }
          }
          ~ li {
            p {
              &::after {
                left: 0;
                right: 0;
              }
            }
          }
        }
        &.active {
          p {
            color: #fff;
            &::after {
              content: "";
              display: block;
              position: absolute;
              left: 0;
              right: 0;
              top: 100%;
              bottom: -5px;
              margin: auto;
              width: 100%;
              @include breakpoint("medium") {
                width: 100%;
              }
              border-bottom: 1px solid color_guide_line("white");
            }
          }
        }
      }
    }
  }
}
.gallery {
  margin: auto;
  width: 70%;
  text-align: center;
}
.nav-item p {
  line-height: 25px;
}
.caption-item p {
  color: white;
  width: 80%;
  margin: 0 auto;
  text-align: center;
  margin-bottom: 20px;
  font-size: 17px;
}
</style>



// WEBPACK FOOTER //
// src/components/carousel.vue